import React from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Container,
} from "@mui/material";
import { Link } from "react-router-dom";
import banner2 from '../assests/banner2.png';
// import "./HomeBanner.css";

const HomeBanner = () => {


    return (
        <div style={{marginTop: { xs: "10px", md: "70px" },
            }}>
              <Container maxWidth="xl">
        <Box>
                    <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={12} lg={12} className="slider-container HomeBannerSlide"> 
           
                
                    <div>
                    <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        justifyContent:"center",
                        flexDirection:'column',
                        background:`url(${banner2})`,
                        backgroundRepeat:"no-repeat",
                        backgroundSize:"cover",
                        borderRadius:'30px',
                        padding:'100px 150px',
                        textAlign:"center",
                    }}>     
        
        <Typography sx={{
                           fontSize:{md:'62px', lg:'72px'},
                           lineHeight:{md:'62px', lg:'72px'},
                           fontWeight:'700',
                           fontFamily: `"Quicksand", sans-serif`,
                           color:'#fff',
        }}>Transform<br/>
Healthcare Logistics</Typography>
<Typography sx={{
                           fontSize:'26px',
                           lineHeight:'40px',
                           fontWeight:'400',
                           fontFamily: `"Quicksand", sans-serif`,
                           color:'#fff',
                           margin:"30px 0 30px"
        }}>Lifeline transforms supply chain variables into reliable procurement solutions, helping leading hospitals and distributors maintain balance across any product challenge.</Typography>
        <Box sx={{
            display:'flex',
                flexDirection:'row',
                gap:"20px",
        }}>
           
            <Button sx={{
            width:'208px',
            height:'56px',
            borderRadius:'0px',
            backgroundColor:'#008BFF',
            color:'#fff',
            fontSize:'16px',
                           lineHeight:'24px',
                           letterSpacing:'0.5px',
                           fontWeight:'500',
                           fontFamily: `"Quicksand", sans-serif`,
                           textTransform:'capitalize',
                           "& a":{
                            color:'#fff',
                           },
        }}>
            <Link to="/shop">
           View Our Products
           </Link>
        </Button>
        {/* <Button sx={{
            width:'208px',
            height:'56px',
            borderRadius:'0px',
            backgroundColor:'transparent',
            border:"1px solid #008BFF",
            color:'#fff',
            fontSize:'16px',
                           lineHeight:'24px',
                           letterSpacing:'0.5px',
                           fontWeight:'500',
                           fontFamily: `"Quicksand", sans-serif`,
                           textTransform:'capitalize',
                           "& a":{
                            color:'#fff',
                           },
        }}>
            <Link to="/lifeline/aboutus">
           Meet Our Team
           </Link>
        </Button> */}
        </Box>
    </Box>
    
    </div>
      
  
        </Grid>
      </Grid>
        </Box>
        </Container>
        </div>
    );
}

export default HomeBanner;